import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router';

const SITE_NAME = 'Alba Iulia — Capitala Tineretului din România 2026';
const SITE_URL = 'https://youthnited.ro';
const DEFAULT_DESCRIPTION =
  'Platforma oficială de evenimente pentru Alba Iulia — Capitala Tineretului din România 2026. Descoperă activități, înscrie-te și fii parte din comunitate.';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

interface DocumentMetaProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article';
}

export function DocumentMeta({ title, description, image, url, type = 'website' }: DocumentMetaProps) {
  const location = useLocation();
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const desc = description || DEFAULT_DESCRIPTION;
  const img = image || DEFAULT_IMAGE;
  const canonical = `${SITE_URL}${url || location.pathname}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="ro_RO" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      <link rel="canonical" href={canonical} />
    </Helmet>
  );
}
